import { render } from "./AssignCoursesList.vue?vue&type=template&id=2330e7de&scoped=true&ts=true"
import script from "./AssignCoursesList.vue?vue&type=script&lang=ts"
export * from "./AssignCoursesList.vue?vue&type=script&lang=ts"

import "./AssignCoursesList.vue?vue&type=style&index=0&id=2330e7de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2330e7de"]])

export default __exports__